import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <section className="page-surface empty-state">
      <h1>Page not found</h1>
      <p>The route is not registered in the ATS SPA frame yet.</p>
      <Link className="primary-button" to="/v2/jobs">
        Go to jobs
      </Link>
    </section>
  );
}
